import { Field, Form, Formik } from 'formik';
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { StyledButton as Button } from '../../CommonComponents/Button';
import FormikInput from '../../CommonComponents/FormikInput';
import Icon from '../../CommonComponents/Icon';
import Label from '../../CommonComponents/Label';
import Modal from '../../CommonComponents/Modal';
import { showError } from '../../CommonComponents/ToastMessenger/ToastMessengerActions';
import { H4 } from '../../CommonComponents/Typography';
import { MESSAGES } from '../../CommonConstants';
import fetchWithDefaults from '../../CommonUtils/fetchWithDefaults';

const StyledModal = styled(Modal)`
  &__content {
    width: 650px;
    padding: 20px;
  }
`;

const WarningPanel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 10px;
`;

const WarningIcon = styled(Icon)`
  font-size: 1.5em;
  color: #ccc;
`;

const WarningText = styled.p`
  margin: 30px;
`;

const Actions = styled.div`
  text-align: right;
  margin-top: 15px;

  ${Button} + ${Button} {
    margin-left: 15px;
  }
`;

const ChangeEmailModal = ({ email, clientId, isOpen, onRequestClose }) => {
  const dispatch = useDispatch();

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const body = new FormData();

      body.append('clientId', values.clientId);
      body.append('email', values.email);

      const response = await fetchWithDefaults('/Consumer/ConsumerEmailUpdate/SaveEmail', {
        method: 'POST',
        body,
      });

      if (response.ok) {
        const { success, errors } = await response.json();

        if (success) {
          window.location.reload();
        } else {
          errors.forEach(error => dispatch(showError(new Error(error))));

          setSubmitting(false);
        }
      } else {
        dispatch(showError(new Error(MESSAGES.GENERIC_ERROR)));

        setSubmitting(false);
      }
    } catch (err) {
      dispatch(showError(new Error(MESSAGES.GENERIC_ERROR)));

      setSubmitting(false);
    }
  };

  return (
    <StyledModal showCloseModalCross isOpen={isOpen} onRequestClose={onRequestClose}>
      <Formik initialValues={{ email, clientId }} onSubmit={handleSubmit}>
        {({ isSubmitting }) => (
          <Form>
            <H4>Change Client Email Address</H4>

            <WarningPanel>
              <WarningIcon className="fa fa-exclamation-triangle" />

              <WarningText>
                Changing a client&apos;s email address may prevent the user from being able to log
                in if the email address is incorrect. Please double check that the email address you
                enter is the correct email address for the client before saving.
              </WarningText>
            </WarningPanel>

            <Label htmlFor="email">Client Email Address</Label>
            <Field
              component={FormikInput}
              id="email"
              name="email"
              type="text"
              maxLength="50"
              placeholder="john.doe@example.com"
            />

            <Actions>
              <Button.Secondary onClick={onRequestClose}>Cancel</Button.Secondary>
              <Button.Primary type="submit" disabled={isSubmitting} isLoading={isSubmitting}>
                Save Changes
              </Button.Primary>
            </Actions>
          </Form>
        )}
      </Formik>
    </StyledModal>
  );
};

ChangeEmailModal.defaultProps = {
  email: '',
};

ChangeEmailModal.propTypes = {
  email: PropTypes.string,
  clientId: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};
export default ChangeEmailModal;
